export default {"src":"/_next/static/media/applyOnline.c5541fd4.svg","height":120,"width":121};